import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import Select from '../common/form/select';

import { setModoTela, initForm } from './saidaActions';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';

class SaidaForm extends Component {

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
	
							<Field
								name='id_tipo'
								component={Select}
								options={this.props.listaTipo.filter(item => (this.props.usuarioCarregado 
									&& this.props.usuarioCarregado.acesso_logistica) || item.id == 1)/*ABASTECIDA*/}
								label='Tipo'
								cols='12 12 12 12'
								placeholder='Selecione o tipo'
								readOnly={readOnly} />

							<Field
								name='id_unidade'
								component={Select}
								options={this.props.listaUnidade}
								label='Unidade'
								cols='12 12 12 12'
								placeholder='Selecione a unidade'
								readOnly={readOnly} />

							<Field
								name='id_produto'
								component={Select}
								options={this.props.listaProduto}
								label='Produto'
								cols='12 6 4 4'
								placeholder='Selecione o produto'
								readOnly={readOnly} />
							
							{this.props.formularioValues.id_tipo == 1 && //Abastecimento
							<Field
								name='id_veiculo'
								component={Select}
								options={this.props.listaVeiculo}
								label='Veículo'
								cols='12 6 4 4'
								placeholder='Selecione o veiculo'
								readOnly={readOnly} />}
								
							{this.props.formularioValues.id_tipo == 1 && //Abastecimento
							<Field
								name='id_motorista'
								component={Select}
								options={this.props.listaMotorista}
								label='Motorista'
								cols='12 6 4 4'
								placeholder='Selecione o motorista'
								readOnly={readOnly} />}
								
							<Field
								name='quantidade'
								component={LabelAndInputNumber}
								label='Quantidade' placeholder='Informe a quantidade'
								cols='12 6 4 4'
								casas={2}
								readOnly={readOnly} />

							{this.props.formularioValues.id_tipo == 1 && //Abastecimento
							<Field
								name='hodometro'
								component={LabelAndInputNumber}
								label='Odômetro' placeholder='Informe o odômetro'
								cols='12 6 4 4'
								casas={0}
								readOnly={readOnly} />}

							{this.props.formularioValues.id_tipo == 1 && //Abastecimento
							<Field
								name='valor'
								component={LabelAndInputNumber}
								label='Valor' placeholder='Informe o valor'
								cols='12 6 4 4'
								casas={2}
								readOnly={readOnly} />}

							<Field
								name='numero_nfe'
								component={LabelAndInput}
								label='Número da Nota' placeholder='Informe o número da nota'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='observacao'
								component={LabelAndInput}
								label='Observação' placeholder='Informe a observação'
								cols='12 12 12 12'
								readOnly={readOnly} />
								
						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>

				</Form>
			</ContentCard>
        )
    }


}

SaidaForm = reduxForm({form: 'saidaForm', destroyOnUnmount: false})(SaidaForm);
const mapStateToProps = state => ({
	sessao: state.auth.saida,
	usuarioCarregado: state.auth.usuarioCarregado,
	formularioValues: getFormValues('saidaForm')(state),
	registro: state.saida.registro,
	listaProduto: state.saida.listaProduto,
	listaUnidade: state.saida.listaUnidade,
	listaTipo: state.saida.listaTipo,
	listaTanque: state.saida.listaTanque,
	listaVeiculo: state.saida.listaVeiculo,
	listaMotorista: state.saida.listaMotorista
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(SaidaForm);
